import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class languageService {


    constructor(private cookieService:CookieService){}


  getCurrentLanguage():string{

    var lang=this.cookieService.get('lang');

    return lang;
  }
  
}
